import { render } from "./MemoryData.vue?vue&type=template&id=896047c2&scoped=true&ts=true"
import script from "./MemoryData.vue?vue&type=script&lang=ts"
export * from "./MemoryData.vue?vue&type=script&lang=ts"

import "./MemoryData.vue?vue&type=style&index=0&id=896047c2&scoped=true&lang=css"
import "./MemoryData.vue?vue&type=style&index=1&id=896047c2&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896047c2"]])

export default __exports__